$(() => {
  document.querySelectorAll('.accordion.accordion-flush .card .collapse.show').forEach(($collapse) => {
    $collapse.closest('.card').classList.toggle('show', true);
  });

  $('.accordion.accordion-flush').on('show.bs.collapse', (ev) => toggleCard(ev, true));
  $('.accordion.accordion-flush').on('hide.bs.collapse', (ev) => toggleCard(ev, false));
});

function toggleCard(ev, show) {
  [...ev.currentTarget.querySelectorAll('.card')].map(($card) => $card.classList.toggle('show', false));
  ev.target.closest('.card').classList.toggle('show', show);
}